import $ from "jquery";

import { Global } from "../global";
import { useCleanEvents } from "../hooks";
import { GlobalService } from "../services";
import * as Shared from "../shared/index";

export const Events = () => {
  const onAjaxComplete = (complete: (payload: any) => void) => {
    document.addEventListener('DOMContentLoaded', () => {
      $.nette.ext("", {
        complete: (payload: any) => {
          useCleanEvents()
          GlobalService.registerAppConfig()
          Global.init()
          Shared.default().initAll(true)
          complete(payload)
        },
      })
    })
  }

  const onBeforeAjaxConfirm = (before: (xhr: any, settings: any) => void) => {
    document.addEventListener("DOMContentLoaded", () => {
      $.nette.ext("confirm", {
        before
      });
    });
  };

  const onDOMLoad = (listener: () => void) => {
    document.addEventListener("DOMContentLoaded", () => {
      GlobalService.registerAppConfig();
      Global.init();
      Shared.default().initAll();
      listener();
    });
  };

  const onLoad = (listener: () => void) => {
    document.addEventListener("load", listener);
  };

  const onNetteExtLoad = (listener: () => void) => {
    document.addEventListener("DOMContentLoaded", () => {
      $.nette.ext("after-load", {
        load: listener
      });
    });
  };

  const onResizeWindow = (listener: () => void) => {
    let resizeTimer: ReturnType<typeof setTimeout>;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        listener();
      }, 250);
    });
  };

  return {
    onAjaxComplete,
    onBeforeAjaxConfirm,
    onDOMLoad,
    onLoad,
    onNetteExtLoad,
    onResizeWindow
  };
};
